import logo from "..\\..\\..\\..\\..\\public\\assets\\oh_structure.png";
import * as React from 'react';
export default {
  logo,
  React
};